import { FC } from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { InformationForm } from 'src/components/organisms/photo-studio/detail/information/form';
import Page from 'src/components/molecules/page';

export const InformationEditPage: FC = () => {
  const title = '詳細情報編集';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <InformationForm />
      </Container>
    </Page>
  );
};
